// Generic remote InvenioRDM proxy client.
// All calls are relative to apiPrefix (e.g. "/api/b2inst").
import { http } from "react-invenio-forms";

function buildUrl(base, params) {
  const urlParams = new URLSearchParams();
  for (const [key, val] of Object.entries(params)) {
    if (Array.isArray(val)) {
      for (const v of val) {
        if (v !== null && v !== undefined && v !== "") urlParams.append(key, v);
      }
    } else if (val !== null && val !== undefined && val !== "") {
      urlParams.append(key, val);
    }
  }
  const qs = urlParams.toString();
  return qs ? `${base}?${qs}` : base;
}

export const fetchCommunities = (apiPrefix) =>
  http.get(`${apiPrefix}/communities`);

export const fetchInstruments = (
  apiPrefix,
  { community = null, q = "", page = 1, size = 10, sort = "newest", filters = {} }
) => {
  const params = { q, page, size, sort };
  if (community) params.community = community;
  for (const [facet, values] of Object.entries(filters)) {
    params[facet] = values;
  }
  return http.get(buildUrl(`${apiPrefix}/instruments`, params));
};
